var scope_0 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/018f0a0c98359d5c1d7a07aa1ccda306.js').default;
var scope_1 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/072b484889eff96a05aba96f7b7552b7.js').default;
var scope_2 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e6333f36a39540ab5ad3fea233b3f71.js').default;
var scope_3 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1014fc3eefc48f463a0a62edf734b474.js').default;
var scope_4 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b368e2f21394d5ebc55d41e590c99e8.js').default;
var scope_5 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/21e04df4ad32f5d06681ed385362a66a.js').default;
var scope_6 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/25f20e1ab3e8b10f1e4434d53119ed15.js').default;
var scope_7 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2d7bfc78e4e29eb4d0a4afc394e260ce.js').default;
var scope_8 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/32066671b001ceeb1bccd07fbafad258.js').default;
var scope_9 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3b3ce87aa4b30ab838c282cee6a6f071.js').default;
var scope_10 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3d89e425e69037dcce5bc073ee84b93e.js').default;
var scope_11 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3f93119a69b0a642ffb0eb88ceafa47f.js').default;
var scope_12 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/401b5e75698a92da249e51e30fb3a09b.js').default;
var scope_13 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42df15b8babbc49ccde0f47e8f36e1f6.js').default;
var scope_14 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/445607dcc7ddd9e82e5cde5fa636607e.js').default;
var scope_15 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/47c6c6733ad4f1203f21ec669b982e67.js').default;
var scope_16 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4c72b4f78e6c85a5d4f569d5909a5737.js').default;
var scope_17 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4f50f5eda28105f03766badf418cd884.js').default;
var scope_18 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4fd0a3d2eca59dd184cc7d7ae449dd53.js').default;
var scope_19 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51d9977dcfb3968d640bd9d3aae23a03.js').default;
var scope_20 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5b0d3ebc2e6184dcb1c46889f3ea8a6d.js').default;
var scope_21 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ee2c40c5531baa68ec4b4c3d33cd34d.js').default;
var scope_22 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/60b7bba5028fd2781a2caf3f23a5d698.js').default;
var scope_23 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/64dc1db97845accb9a14cc1db6b9f17b.js').default;
var scope_24 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/67a1351c127fc95f09bdf756eb31de1a.js').default;
var scope_25 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/865e80fabc2f874be808cba77b893421.js').default;
var scope_26 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8ce47e67fa9add87012b85c65e06e16d.js').default;
var scope_27 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9cb3d75188e973eee9dfca10bd718392.js').default;
var scope_28 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9dcb4ec492e2ff29de05365f0f3628ff.js').default;
var scope_29 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a1ac15604f47cbc65c84652d40c58a85.js').default;
var scope_30 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a4761fe795b97852414094beeef4b120.js').default;
var scope_31 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a527f2cf8475e82b85d448f3074af198.js').default;
var scope_32 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a5344b2b7408c6dd533e47a1b39d74dc.js').default;
var scope_33 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a990a8ceb8266b6262f341c684af334c.js').default;
var scope_34 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/afbf5e9bd5dbefe8a515ce6e76123c36.js').default;
var scope_35 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8698472e2f74b0a1cf81e455afe3629.js').default;
var scope_36 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9aee6ba49ca1e6cf5f2d82c31cd3e70.js').default;
var scope_37 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bf7b61a72e57d8c0a7aa0018cd8e51ef.js').default;
var scope_38 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cafaf5ec55376b956c9f5748f7f2d498.js').default;
var scope_39 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cbf2d925fd412ad82626d65bca7d8408.js').default;
var scope_40 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cee26a857708b39e3d8027b096472c19.js').default;
var scope_41 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4d6b86ac7839120914d15f872e0549a.js').default;
var scope_42 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d85dcf431345e1e3a700e41e9227d056.js').default;
var scope_43 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dee12d938086209be59b046f5f70244f.js').default;
var scope_44 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e309ae2bf0cd96fe8ef9ad4b228bdb1c.js').default;
var scope_45 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e4196d54ad79c14ac799cc38a42ad511.js').default;
var scope_46 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e44c07c6f23376cb3e5644c32acc54d1.js').default;
var scope_47 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eae0ac314218f5236fed7a9ede3871cf.js').default;
var scope_48 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec32d63aac5e6efecb95ff7cbc1bae45.js').default;
var scope_49 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ece932da885e6fa0b96c86b01f88c604.js').default;
var scope_50 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ed6ff2e857733ad18d2d8b16dbc624ac.js').default;
var scope_51 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/efff1896d435d258b533f8c93a04ce63.js').default;
var scope_52 = require('C:/Users/tsuto/webapp/pcrecommend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f92b2d9952649cfc568089ed0b982efd.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22,
scope_23,
scope_24,
scope_25,
scope_26,
scope_27,
scope_28,
scope_29,
scope_30,
scope_31,
scope_32,
scope_33,
scope_34,
scope_35,
scope_36,
scope_37,
scope_38,
scope_39,
scope_40,
scope_41,
scope_42,
scope_43,
scope_44,
scope_45,
scope_46,
scope_47,
scope_48,
scope_49,
scope_50,
scope_51,
scope_52 )
    